import { render } from "./ecosystemSection.vue?vue&type=template&id=2a772a04&scoped=true"
import script from "./ecosystemSection.vue?vue&type=script&lang=js"
export * from "./ecosystemSection.vue?vue&type=script&lang=js"

import "./ecosystemSection.vue?vue&type=style&index=0&id=2a772a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a772a04"]])

export default __exports__